import apiBase from './apiBase';

class ZonesApi {
  static getAllZones() {
    return apiBase.create().get('/mobile/zones?api-version=2');
  }
}

export default ZonesApi;
